import React from "react";
import "../index.css";
export default function Loader() {
  return (
    <div>
      <span class="loader"></span>
    </div>
  );
}
